import session from '@ep/tools/session';
import { openMenuBySlug } from '@ep/components/create/menu';

const openOpportunitiesBoard = async ({ record = {} } = {}) => {
  const useBoardId = String(record.useBoardId || record.id || '').trim();
  if (!useBoardId) throw new Error('USE_BOARD_ID_REQUIRED');
  session.set('boardUseBoardId:admindigital:crm', useBoardId);
  return openMenuBySlug('admindigital/crm/deals/opportunities');
};

export default {
  'board.openUseBoard': { run: openOpportunitiesBoard },
};
